import { connect } from 'react-redux'

import UsDollarsNotice from './usDollarsNotice'

const mapStateToProps = state => {
  const { user: { usDollarsNotice } } = state

  return { notice: usDollarsNotice }
}

const UsDollarsNoticeContainer = connect(mapStateToProps, null)(UsDollarsNotice)

export default UsDollarsNoticeContainer



// WEBPACK FOOTER //
// ./client/components/usDollarsNotice/usDollarsNoticeContainer.js